import { getError } from "@/utils/get-error";
import { axiosInstance } from "@dexteel/mesf-core";
import { Axios } from "axios";

export class PartComponentTypeRepository {
	private axios: Axios;

	constructor() {
		this.axios = axiosInstance;

		this.getPartComponentType = this.getPartComponentType.bind(this);
		this.getPartByComponentType = this.getPartByComponentType.bind(this);
		this.getComponentTypeByPart = this.getComponentTypeByPart.bind(this);
		// this.updateComponentTypeByPart = this.updateComponentTypeByPart.bind(this)
		// this.updatePartByComponentType = this.updatePartByComponentType.bind(this)
	}

	async getPartComponentType() {
		try {
			const resp = await this.axios.get("/PartComponentType/");

			return {
				ok: true,
				data: resp,
			};
		} catch (error: any) {
			const message = getError(error);
			return Promise.reject(message);
		}
	}

	async getPartByComponentType(componentTypeId: number | null) {
		try {
			const resp = await this.axios.get(
				`/PartCOmponentType/${componentTypeId}/parts`,
			);

			return {
				ok: true,
				data: resp,
			};
		} catch (e: any) {
			return { ok: false, message: e.toString() };
		}
	}
	async getComponentTypeByPart(partId: number | null) {
		try {
			const resp = await this.axios.get(
				`/PartComponentType/${partId}/component-types/`,
			);

			return {
				ok: true,
				data: resp,
			};
		} catch (e: any) {
			return { ok: false, message: e.toString() };
		}
	}
}

export const {
	getPartComponentType,
	getPartByComponentType,
	getComponentTypeByPart,
	// updatePartByComponentType,
	// updateComponentTypeByPart
} = new PartComponentTypeRepository();
